import { getSoxCycles as getFallbackSoxCycles, availableSoxCycles as fallbackAvailableSoxCycles } from './soxCycleReference';

function normalizeText(value) {
  return String(value ?? '').trim().toLowerCase();
}

function uniqueCycleCodes(values) {
  const list = Array.isArray(values) ? values : [];
  const out = [];
  const seen = new Set();
  list.forEach((entry) => {
    const code = String(entry ?? '').trim();
    if (!code || seen.has(code)) return;
    seen.add(code);
    out.push(code);
  });
  return out;
}

export function resolveSoxCyclesWithDefaults({
  mappings,
  itemLabel,
}) {
  const label = String(itemLabel ?? '').trim();
  if (!label) return getFallbackSoxCycles('');

  const labelKey = normalizeText(label);
  if (mappings && typeof mappings === 'object') {
    const exact = uniqueCycleCodes(mappings[labelKey]);
    if (exact.length > 0) return exact;
  }

  const mappingKeys = mappings && typeof mappings === 'object' ? Object.keys(mappings) : [];
  for (const rawKey of mappingKeys) {
    const key = normalizeText(rawKey);
    if (labelKey.includes(key) || key.includes(labelKey)) {
      const matched = uniqueCycleCodes(mappings[rawKey]);
      if (matched.length > 0) return matched;
    }
  }

  return getFallbackSoxCycles(label);
}

export function getAvailableSoxCyclesFromApiData(defaultsApiData, options = {}) {
  const { strict = false } = options;

  const emptyOrReferenceFallback = () => (strict ? [] : fallbackAvailableSoxCycles);

  if (!defaultsApiData || typeof defaultsApiData !== 'object') {
    return emptyOrReferenceFallback();
  }

  const cycleNames = defaultsApiData.cycle_names;
  if (cycleNames && typeof cycleNames === 'object' && !Array.isArray(cycleNames)) {
    const cycles = Object.entries(cycleNames)
      .map(([code, name]) => {
        const cycleCode = String(code ?? '').trim();
        if (!cycleCode) return null;
        const cycleName = String(name ?? cycleCode).trim() || cycleCode;
        return { code: cycleCode, name: cycleName, description: cycleName };
      })
      .filter(Boolean);
    if (cycles.length > 0) return cycles;
  }

  return emptyOrReferenceFallback();
}
